module.exports = __webpack_public_path__ + "static/media/eat_icon.66c55bef.svg";